<p-table [value]="visibilityGroups" dataKey="id" [expandedRowKeys]="expandedRows">
    <ng-template pTemplate="header">
        <tr>
            <th style="width:2rem"></th>
            <th>Name</th>
            <th>Channel Name</th>
            <th>Last Updated</th>
            <th>Count</th>
            <th>Is Active</th>
            <th>Is Default</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-group let-expanded="expanded" let-i="rowIndex">
        <tr class="parent-color">
            <td class="action">
                <p-button type="button" pRipple [pRowToggler]="group" [text]="true" [rounded]="true" [plain]="true"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
            </td>
            <td>{{ group.groupName }}</td>
            <td>-</td>
            <td>{{ group.updatedDate | date: "MMM dd, yyyy '|' hh:mm a" }} by {{group.updatedByName}}</td>
            <td>-</td>
            <td>{{ group.isActive ? "Yes" : "No" }}</td>
            <td class="action">
                <p-radioButton [disabled]="!group.isActive" [value]="true" [(ngModel)]="group.isDefault"
                    (onClick)="makeVisibilityGroupDefault(group)"></p-radioButton>
                {{group.isDefault ? 'Yes': 'No'}}
            </td>
            <td class="action">
                <span class="btnBars" *ngIf="group.createdSource!='system'" (click)="editGroup(group)" pTooltip="Edit"
                    tooltipPosition="top">
                    <i class="pi pi-pencil"></i>
                </span>
                <span class="btnBars" (click)="deleteGroup(group.id,i)" pTooltip="Delete" tooltipPosition="top"
                    *ngIf="group.createdSource!='system' && !group.isDefault">
                    <i class="pi pi-trash"></i>
                </span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-group let-i="rowIndex">
        <tr *ngFor="let child of group.children">
            <td></td>
            <td><span class="p-ml-3">{{ child.text }}</span></td>
            <td>{{ child.channelName }}</td>
            <td></td>
            <td>{{ child.count }}</td>
            <td></td>
            <td></td>
            <td class="action">
                <span class="btnBars" (click)="addVisibility(group,child,false)" pTooltip="Add" tooltipPosition="top"
                    *ngIf="i !== 0">
                    <i class="pi pi-plus"></i>
                </span>
                <span class="btnBars" *ngIf="child.count>0" (click)="addVisibility(group,child,true)" pTooltip="View" tooltipPosition="top">
                    <i class="pi pi-list"></i>
                </span>
            </td>
        </tr>
    </ng-template>
</p-table>
<div *ngIf="visibilityGroups?.length == 0" class="centered-spinner" style="margin: auto;">
    <p-progressSpinner [style]="{width: '40px', height: '40px'}" strokeWidth="4"></p-progressSpinner>
</div>

<p-dialog header="{{addEditGroupHeader}}" [modal]="true" [(visible)]="displayAddGroup" [style]="{width: '50vw'}"
    (onHide)="hideDialog()">
    <form [formGroup]="groupForm">
        <div class="header p-d-flex p-jc-between">
            <h5>Group Information</h5>
            <p-inputSwitch formControlName="statusId" [disabled]="groupForm.controls['isDefault']?.value" />
        </div>
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label for="name">Name <span style="color: red;">*</span></label>
                    <input type="text" pInputText formControlName="groupName" />
                    <span *ngIf="invalidData" class="p-invalid">Name already exists.</span>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="hideDialog()" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="saveGroup(groupForm.value)" [disabled]="!groupForm.valid" label="Save"></button>
    </ng-template>
</p-dialog>

<!-- accounts -->
<p-dialog [modal]="true" [(visible)]="displayAddAccounts" [style]="{width:'50vw',height:'30vw'}" [closable]="true"
    (onHide)="accountForm.reset();">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0">Add {{fromAccount ? 'Account' : 'Product'}}</h5>
        </div>
    </ng-template>
    <div class="card">
        <ng-container>
            <form [formGroup]="accountForm">
                <div class="p-grid">
                    <div class="p-col-6">
                        <label>Module <span style="color:red">*</span></label>
                        <p-dropdown appendTo="body" [options]="allModules" name="allModules" formControlName="moduleId"
                            optionLabel="name" dataKey="id" placeholder="Select a  Module">
                        </p-dropdown>
                    </div>
                    <div class="p-col-6">
                        <label>Channel <span style="color:red">*</span></label>
                        <p-dropdown appendTo="body" [options]="allChannels" name="allChannels"
                            formControlName="channelId" optionLabel="name" id="allChannels" dataKey="id"
                            placeholder="Select Channel" (onChange)="onChannelChange($event)">
                        </p-dropdown>
                    </div>
                    <div class="p-col-6">
                        <div class="p-field-checkbox">
                            <p-checkbox formControlName="selectAll" [ngStyle]="{verticalAlign: 'middle' }" binary="true"
                                inputId="selectAll" (onChange)="onChannelChange($event)"></p-checkbox>
                            <label for="selectAll" style="padding: 5px;margin:0px">Select All {{accountForm.controls['moduleId'].value?.name}}s</label>
                        </div>
                    </div>
                    <div class="p-col-6" *ngIf="!accountForm.controls['selectAll'].value">
                        <div class="p-d-flex" *ngFor="let option of radioOptions; let i = index">
                            <p-radioButton 
                              [value]="option.value" 
                              formControlName="ruleId" 
                              [inputId]="'option' + i" 
                              (click)="onChannelChange($event)">
                            </p-radioButton>
                            <label [for]="'option' + i" class="p-ml-2">
                              Add {{accountForm.controls['moduleId'].value?.name}} {{option.label}}
                            </label>
                          </div>
                        @if(!accountForm.controls['ruleId'].value && accountForm.controls['channelId'].value){
                        <app-filters [listCols]="filterCols"
                            [selectedParentModule]="{name:accountForm.controls['moduleId'].value?.name,objectId:accountForm.controls['moduleId'].value?.objectId,channelId:accountForm.controls['channelId'].value?.id}"
                            [fromProductVisibilityModule]="true" [saveFilterData]="savedFilterData"
                            (applyFiltersColumns)="applyFilters($event)"></app-filters>
                        }
                    </div>
                </div>
            </form>
            <!-- <ng-container *ngIf="!accountForm.controls['ruleId'].value && !accountForm.controls['selectAll'].value">
                <app-saved-search-main-module-rules-selection [selectedParentModule]="accountForm.controls['moduleId'].value"
                    [selectedParentTemplate]="accountForm.controls['channelId'].value" [isMainModule]="true" [ruleData]="ruleData"
                    [ruleList]="ruleList" [lastRuleValues]="lastRuleValues"></app-saved-search-main-module-rules-selection>
            </ng-container> -->
            <div class="header p-d-flex p-jc-between" *ngIf="!accountForm.controls['ruleId'].value && ruleData.length > 0">
                <h5 class="p-mt-2">Rule List</h5>
            </div>
            <div class="card" *ngIf="!accountForm.controls['ruleId'].value && ruleData.length > 0">
                <div class="p-field p-grid">
                    <div class="p-col-12">
                        <p-table [value]="ruleData">
                            <ng-template pTemplate="header">
                              <tr>
                                <th>Rule No.</th>
                                <th>Choice</th>
                                <th>Filter</th>
                                <th>Operator</th>
                                <th>Value</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rule let-i="rowIndex">
                              <tr>
                                <td>#{{i+1}}</td>
                                <td>{{i==0 ? '-' : rule.operationType}}</td>
                                <td>{{accountForm.controls['moduleId'].value?.name}}({{accountForm.controls['channelId'].value?.name}}){{rule.displayName}}</td>
                                <td>{{rule.operator}}</td>
                                <td>{{transformData(rule.values)}}</td>
                              </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="getDataLists(true)" label="Preview" *ngIf="!(accountForm.controls['ruleId'].value || accountForm.controls['selectAll'].value)"
        class="p-button-primary" [disabled]="ruleData?.length==0"></button>
        <button pButton (click)="displayAddAccounts=false;" label="{{'Configuration.User.Cancel' | transloco}}"
            class="p-button-secondary"></button>
        <button type="button" *ngIf="accountForm.controls['moduleId'].value && accountForm.controls['channelId'].value"
            pButton [label]="(accountForm.controls['selectAll'].value || !accountForm.controls['ruleId'].value) ? 'Save' : 'Next'"
            [disabled]="!accountForm.controls['selectAll'].value && !accountForm.controls['ruleId'].value && ruleData?.length==0"
            (click)="accountForm.controls['selectAll'].value ? saveAssignData(accountForm.getRawValue(),true) : getDataLists(accountForm.controls['ruleId'].value? true:false)"></button>
    </ng-template>
</p-dialog>


@if(displayModuleDataList){
<app-shared-manual-modal [headerTitle]="manualHeaderTitle" [viewOnly]="isFromView"
    [displayPopup]="displayModuleDataList" [colsList]="moduleColumnSetttings"
    [selectedObjectType]="accountForm.controls['moduleId'].value"  [fromProductVisibilityModule]="true"
    [fromRule]="fromRule" [selectedAccount]="selectedRecordList" [ruleList]="ruleData"
    [selectedTemplateType]="accountForm.controls['channelId'].value" [preview]="preview"
    (saveAssignDataclicked)="saveAssignData(accountForm.getRawValue(),$event)"
    (backToModuleClicked)="backToModuleClicked()" (cancelClicked)="cancelClickedModuleDataList()">
</app-shared-manual-modal>
}

@if(displayProductList){
 <app-productvisibility-list [displayProductSelectionModal]="displayProductList" [productChannels]="allChannels"
  [selectedChannel]="accountForm.controls['channelId'].value" [viewOnly]="isFromView" [selectedProductsList]="selectedRecordList" 
  [preview]="preview"  [ruleList]="ruleData" [fromRule]="fromRule"
  (onCancelClicked)="cancelProductAdd($event)" (onProductAddComplete)="saveAssignData(accountForm.getRawValue(),$event)">
</app-productvisibility-list>
}
